import React, { Component } from 'react';
import PInput from './PInput';

export default class FormAlumno extends Component {

  constructor(props){
    super(props);

    if(props.data!==undefined && props.data!==null){
      this.state = {
        form: {
          'nombres': props.data.nombres,
          'apellidos': props.data.apellidos,
          'ci': props.data.ci,
          'profesion': props.data.profesion,
          'residencia': props.data.residencia,
          'email': props.data.email,
          'telefono': props.data.telefono,
          'contrasenha': "",
          'conf_contrasenha': ""
        },
        errors: {}
      };
    } else {
      this.state = {
        form: {
          'nombres': "",
          'apellidos': "",
          'ci': "",
          'profesion': "",
          'residencia': "",
          'email': "",
          'telefono': "",
          'contrasenha': "",
          'conf_contrasenha': ""
        },
        errors: {}
      };
    }

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  isValid(){
    let data = this.state.form;
    let errors = {};
    if (data.nombres.length < 3) {
      errors["nombres"] = "Su nombre debe tener al menos 3 carácteres";
    }
    if (data.apellidos.length < 3) {
      errors["apellidos"] = "Su apellido debe tener al menos 3 carácteres";
    }
    if (data.residencia.length < 3) {
      errors["residencia"] = "Su residencia debe tener al menos 3 carácteres";
    }
    if (data.email.length === 0) {
      errors["email"] = "Su correo debe tener al menos 3 carácteres";
    }
    if (data.contrasenha.length < 6) {
      errors["contrasenha"] = "Su contraseña debe tener al menos 6 carácteres";
    }
    if (data.conf_contrasenha.length < 3 || data.contrasenha !== data.conf_contrasenha) {
      if(errors['contrasenha'] === undefined)
        errors["contrasenha"] = "Las contraseñas no coinciden";
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return false;
    }
    return true;
  }

  handleChange(event){
    let form = Object.assign({}, this.state.form);
    form[event.target.name] = event.target.value;
    this.setState({ form });
  }

  onSubmit(event){
    event.preventDefault();

    if(this.isValid()) this.props.submit(this.state.form);
  }
  render(){
    return (
      <form onSubmit={this.onSubmit}>
        <PInput name="nombres"
          description="Nombres *"
          handleChange={this.handleChange}
          value={this.state.form['nombres']}
          error={this.state.errors['nombres']} />
        <PInput name="apellidos"
          description="Apellidos *"
          handleChange={this.handleChange}
          value={this.state.form['apellidos']}
          error={this.state.errors['apellidos']} />
        <PInput name="residencia"
          description="Residencia *"
          handleChange={this.handleChange}
          value={this.state.form['residencia']}
          error={this.state.errors['residencia']} />
        <PInput name="profesion"
          description="Profesión"
          handleChange={this.handleChange}
          value={this.state.form['profesion']}
          error={this.state.errors['profesion']} />
        <PInput name="ci"
          description="CI"
          handleChange={this.handleChange}
          value={this.state.form['ci']}
          error={this.state.errors['ci']} />
        <hr />
        <PInput name="email"
          description="Correo *"
          type="email"
          handleChange={this.handleChange}
          value={this.state.form['email']}
          error={this.state.errors['email']} />
        <PInput name="telefono"
          description="Teléfono"
          type="phone"
          handleChange={this.handleChange}
          value={this.state.form['telefono']}
          error={this.state.errors['telefono']} />
        <PInput name="contrasenha"
          description="Contraseña *"
          handleChange={this.handleChange}
          type="password"
          value={this.state.form['contrasenha']}
          error={this.state.errors['contrasenha']}
          autoComplete="nope" />
        <PInput name="conf_contrasenha"
          description="Confirmar Contraseña *"
          handleChange={this.handleChange}
          type="password"
          value={this.state.form['conf_contrasenha']}
          error={this.state.errors['conf_contrasenha']}
          autoComplete="nope" />
        <button className="btn btn-primary" type="submit">{this.props.submitText}</button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/forms/form_alumno.js